import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Layout } from './components/layouts/Layout'
import { IndexPage } from './pages/index'
import { PrivacyPage } from './pages/privacy'
import { TermsPage } from './pages/terms'
import { ContactPage } from './pages/contact'
import { SunsetPage } from './pages/sunset'
import { NotFoundPage } from './pages/not-found'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <IndexPage />,
      },
      {
        path: 'login',
        element: <Navigate to="/sunset" replace />,
      },
      {
        path: 'pricing',
        element: <Navigate to="/sunset" replace />,
      },
      {
        path: 'billing/*',
        element: <Navigate to="/sunset" replace />,
      },
      {
        path: 'callback/*',
        element: <Navigate to="/sunset" replace />,
      },
      {
        path: 'invite/*',
        element: <Navigate to="/sunset" replace />,
      },
      {
        path: 'privacy',
        element: <PrivacyPage />,
      },
      {
        path: 'terms',
        element: <TermsPage />,
      },
      {
        path: 'legal',
        element: <Navigate to="/sunset" replace />,
      },
      {
        path: 'contact',
        element: <ContactPage />,
      },
      {
        path: 'sunset',
        element: <SunsetPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])
